import { useQuery } from '@tanstack/react-query';
import { RequestsKey } from './types';
import { requestsRepo } from '@/constants/providers';
import { OrganizationContext } from '@/components/OrganizationProvider/OrganizationProvider';
import { useContext } from 'react';

export const useGetRequestDetails = (requestId: number) => {
  const { organizationId } = useContext(OrganizationContext);
  return useQuery({
    queryKey: [...RequestsKey.DETAILS(requestId), organizationId],
    enabled: !!requestId,
    queryFn: () => {
      return requestsRepo.getDetails(requestId);
    },
  });
};
